var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmExit = function SvgConfirmExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#confirmExit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 65c6 4 13 7.82 13 15 0 6.89-4.23 10.7-11 11h-2V65ZM65 49a27 27 0 0 0-27 27v37h54V76a27 27 0 0 0-27-27Zm-53 8v25a26.24 26.24 0 0 0 1.89 9.79 26.56 26.56 0 0 0 10 12.09L38 113V50.91L12 57Z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 78h5a2 2 0 0 1 2 2h-7v-2Z",
    fill: "#FFB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 79h-4v1h4v-1Z",
    fill: "#192C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 57v25a26.24 26.24 0 0 1-1.89 9.79 26.56 26.56 0 0 1-10 12.09L38 113V50.91L64 57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.37 48.59-3.94-3.35A5.18 5.18 0 0 0 96.07 44h-6.16a5.16 5.16 0 0 0-3.36 1.24l-3.94 3.35A4.6 4.6 0 0 0 81 52.08v7.46a4.599 4.599 0 0 0 2 3.82l2.8 1.87a4.63 4.63 0 0 0 2.55.77H90l1 1-1 4v27l-1-1h-6v2h3v3h-3v2h3v3h-3v2h6l1-1v2.88a2.12 2.12 0 0 0 2.12 2.12h1.76a2.118 2.118 0 0 0 2.12-2.12V71l-1-4 1-1h1.59a4.63 4.63 0 0 0 2.55-.77l2.8-1.87a4.595 4.595 0 0 0 2-3.82v-7.46a4.6 4.6 0 0 0-1.57-3.49ZM98 58.92A1.08 1.08 0 0 1 96.92 60h-7.84A1.08 1.08 0 0 1 88 58.92v-.84A1.08 1.08 0 0 1 89.08 57h7.84A1.08 1.08 0 0 1 98 58.08v.84Z",
    fill: "#116DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 36a13 13 0 1 1-26 0c0-3.448 1.37-5.754 3.808-8.192a13 13 0 0 1 18.384 0C76.63 30.246 78 32.552 78 36Zm25 49.16V80H90.17A2.17 2.17 0 0 0 88 82.17v6.66A2.17 2.17 0 0 0 90.17 91h7a5.83 5.83 0 0 0 5.83-5.84Z",
    fill: "#FFB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 36a13 13 0 0 1-1 5l-12-9-12 9.06A13 13 0 1 1 78 36Zm-5-21a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM43 72a5 5 0 1 0-8.13 3.87L33 88h10l-1.87-12.13A5 5 0 0 0 43 72Zm53-6h-6v5h6v-5Zm-6 31h-1v12h1V97Z",
    fill: "#192C55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "confirmExit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgConfirmExit;